<template>
  <nav class="navbar navbar-expand-lg navbar-dark">
    <div class="container">
      <span class="navbar-brand flex-grow-1 mb-0 h1">
        <router-link to="/" class="home">{{ organisationName }}</router-link>
      </span>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <div class="d-flex">
          <span class="navbar-text">
            {{ $t('header.logged-in-as') }} <strong>{{ name }}</strong>
          </span>
        </div>
        <ul class="navbar-nav">
          <li class="nav-item">
            <span class="navbar-divider d-none d-lg-block">|</span>
            <router-link to="/contact" class="nav-link">{{
              $t('header.contact')
            }}</router-link>
          </li>
          <li class="nav-item">
            <span class="navbar-divider d-none d-lg-block">|</span>
            <a v-on:click="logout" class="nav-link">{{
              $t('header.logout')
            }}</a>
          </li>
          <li class="nav-item">
            <span class="navbar-divider d-none d-lg-block">|</span>
            <locale-switcher></locale-switcher>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { Action as SessionAction } from '@/store/session/types';
import LocaleSwitcher from './LocaleSwitcher.vue';

export default {
  components: { LocaleSwitcher },
  name: 'Header',
  computed: {
    organisationName() {
      return this.$store.state.user.organisation.name;
    },
    name() {
      return this.$store.state.user.user.first_name;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch(`${SessionAction.LOGOUT}`).then(() => {
        window.location = process.env.VUE_APP_LOGIN_URL;
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
